'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _modal = require('../../modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'video-modal';

var MPPVideoModal = function (_React$Component) {
  _inherits(MPPVideoModal, _React$Component);

  function MPPVideoModal() {
    _classCallCheck(this, MPPVideoModal);

    return _possibleConstructorReturn(this, (MPPVideoModal.__proto__ || Object.getPrototypeOf(MPPVideoModal)).apply(this, arguments));
  }

  _createClass(MPPVideoModal, [{
    key: 'render',
    value: function render() {
      var youtubeVideoIdMatch = /^[\w-_]{10,12}/;
      var youtubeFullUrlMatch = /(?:https?:\/\/)?www\.youtube\.com\/watch\?v=([a-zA-Z0-9-_]+)/;
      /* eslint-disable max-len */
      var youtubeEmbedUrlMatch = /(?:https?:\/\/)?www\.youtube-nocookie\.com\/embed\/([a-zA-Z0-9-_]+)/;
      /* eslint-enable max-len */
      var youtubeShortUrlMatch = /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9-_]+)/;
      var paypalVideoUrlMatch = /(?:https?:\/\/)?www\.paypalobjects\.com.+\.[mp4|webm]{1,}/;

      var youtubeId = this.props.videoId.match(youtubeFullUrlMatch) && this.props.videoId.match(youtubeFullUrlMatch)[1] || this.props.videoId.match(youtubeEmbedUrlMatch) && this.props.videoId.match(youtubeEmbedUrlMatch)[1] || this.props.videoId.match(youtubeShortUrlMatch) && this.props.videoId.match(youtubeShortUrlMatch)[1] || this.props.videoId.match(youtubeVideoIdMatch) && this.props.videoId.match(youtubeVideoIdMatch)[0];

      var paypalVideoUrl = this.props.videoId.match(paypalVideoUrlMatch) && this.props.videoId.match(paypalVideoUrlMatch)[0];

      var youtubeUrl = 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?rel=0&autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=0&showinfo=0&hd=1&modestbranding=1';

      var videoHTML = youtubeId ? _react2.default.createElement('iframe', {
        sandbox: 'allow-scripts allow-same-origin allow-popups',
        className: 'youtube-iframe',
        src: youtubeUrl,
        frameBorder: '0',
        allowFullScreen: true,
        title: 'youtube-iframe'
      }) : _react2.default.createElement(
        'video',
        {
          className: ORGANISM_NAME + '__video',
          controls: true,
          src: paypalVideoUrl,
          frameBorder: '0',
          autoPlay: true,
          allowFullScreen: true
        },
        _react2.default.createElement('track', { kind: 'captions' })
      );

      return _react2.default.createElement(
        _modal2.default,
        {
          show: this.props.show,
          bodyRef: this.props.bodyRef,
          closeModal: this.props.closeModal
        },
        videoHTML
      );
    }
  }]);

  return MPPVideoModal;
}(_react2.default.Component);

exports.default = MPPVideoModal;


MPPVideoModal.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  videoId: _propTypes2.default.string,
  closeModal: _propTypes2.default.func.isRequired,
  bodyRef: _propTypes2.default.object
};

MPPVideoModal.defaultProps = {
  videoId: 'hNDGButFswM',
  bodyRef: undefined
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/video-modal/jsx/MPPVideoModal.js
// module id = 690
// module chunks = 4